import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "umi";
import { Text, TextProps } from "tea-component";
import { useLocal } from "@/pages/dashboard/utils/customHook";

interface ISubTitle extends TextProps<any> {
  subTitleEn?: string;
  subTitleCN?: string;
}

export const SubTitle = (props: ISubTitle) => {
  const { subTitleEn = '', subTitleCN = '', ...restProps } = props || {};
  const { isEN } = useLocal();
  const { timeZone = '+0' } = useSelector((state: any) => ({
    timeZone: state?.dashboardSetting?.gameConfig?.time_zone
  }), shallowEqual);

  const subTitle = useMemo(() => {
    const timeZoneSubTitleEn = `Timezone (UTC${timeZone})`;
    const timeZoneSubTitleCN = `时区 (UTC${timeZone})`;
    const timeZoneSubTitle = (isEN && timeZoneSubTitleEn ? timeZoneSubTitleEn : timeZoneSubTitleCN) || '';
    const propsSubTitle = (isEN && subTitleEn ? subTitleEn : subTitleCN) || '';
    return propsSubTitle || timeZoneSubTitle;
  }, [isEN, subTitleCN, subTitleEn, timeZone]);

  return <Text theme="label" {...restProps}>{subTitle}</Text>;
};